import Link from 'next/link';
import PropTypes from 'prop-types';
import { FiArrowLeft } from 'react-icons/fi';

import TypographyWithIcon from './TypographyWithIcon';

const BackLink = ({ name, href }) => {
    return (
        <Link color="inherit" href={href} passHref>
            <TypographyWithIcon
                icon={<FiArrowLeft />}
                variant="h5"
                component="p"
                style={{ cursor: 'pointer' }}
                noWrap
            >
                {name && `Back to ${name}`}
            </TypographyWithIcon>
        </Link>
    );
};

BackLink.propTypes = {
    name: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
};

export default BackLink;
